import type {StreamEvent, StreamState, StreamObserver} from '../types';
import type {StreamController} from '../stream-controller';

/**
 * Base implementation of StreamObserver
 * Observers should extend this class instead of implementing StreamObserver directly
 */
export abstract class BaseStreamObserver<
  ChunkType = StreamEvent,
> implements StreamObserver<ChunkType> {
  abstract name: string;
  protected controller?: StreamController<ChunkType>;

  setController(controller: StreamController<ChunkType> | undefined): void {
    this.controller = controller;
  }

  protected getStreamState(): StreamState | undefined {
    return this.controller?.getState();
  }

  abstract onChunk(chunk: ChunkType): void | Promise<void>;

  onEnd(): void | Promise<void> {}

  onStart(): void | Promise<void> {}

  onError(err: unknown): void {
    console.error(`[${this.name}] Observer error:`, err);
  }
}
